import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "notification",
  "use": "notification-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"notification\"><path d=\"M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1.1 12.8c0 .3-.2.5-.4.5H7.3c-.2 0-.4-.2-.4-.5v-1.2c0-.3.2-.5.5-.5h1.2c.3 0 .5.2.5.5v1.2zm-.6-2.7H7.4c-.4 0-.6-.3-.6-.6V3.2c0-.4.2-.6.5-.6h1.2c.4 0 .5.2.5.6v6.3c.1.4-.1.6-.5.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/notification.svg
// module id = 206
// module chunks = 0